<template>
    <section
        class="mx-auto flex h-full min-h-[500px] w-full max-w-4xl flex-col items-center justify-center gap-y-0 overflow-hidden px-6 pb-4 text-center text-white xl:max-w-5xl"
    >
        <div class="mx-auto min-h-0 flex-shrink-0">
            <h2 class="text-2xl font-bold text-white md:text-4xl" tabindex="-1">
                {{ slide.headline }}
            </h2>

            <div
                v-if="slide.body"
                class="mx-auto mt-4 max-w-xl md:text-lg xl:text-xl"
                v-html="slide.body"
            ></div>
        </div>

        <div
            class="my-2 flex max-h-[450px] min-h-0 w-full items-center justify-center md:flex-1"
        >
            <img
                v-if="slide.mainImage"
                :src="slide.mainImage?.url"
                :alt="slide.mainImage?.alt"
                class="mx-auto h-full max-h-full w-auto object-contain"
            />
        </div>
        <div class="w-full flex-shrink-0">
            <button
                type="button"
                class="inline-block w-3/4 rounded-full bg-white px-10 py-2.5 text-center font-semibold text-blue shadow-sm duration-150 hover:bg-blue hover:text-white hover:ring-2 hover:ring-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky md:w-auto"
                @click="startQuiz"
            >
                {{ slide.ctaLabel }}
            </button>
        </div>
    </section>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { useQuizStore } from "../stores/quizStore";
import { useAnalyticsStore } from "../stores/analyticsStore";
import type { IntroCardSlide } from "../types";

const props = defineProps<{ slide: IntroCardSlide }>();
const router = useRouter();
const quiz = useQuizStore();
const analytics = useAnalyticsStore();

function startQuiz() {
    quiz.setStarted(true);
    const firstQ = quiz.questions[0];
    analytics.fireOnce("quiz_started", {});
    if (firstQ)
        router.push({
            name: "questionIntro",
            params: { id: firstQ.questionId },
        });
}
</script>
